import DownloadCardGrid from "./DownloadCardGrid";
import ScrollDownIndicator from "./ScrollDownIndicator";
import { useTranslation } from "react-i18next";

import "../styles/Downloads.css";

const activityReports = [
  {
    title: "activity_report_2025_title",
    text: "activity_report_2025_text",
    downloadTitle: "activity_report_2025_download_title",
    downloadLinks: [
      {
        name: "activity_report_2025_download_name_pdf",
        url: "DownloadDocuments/Raport_referitor_la_activitatea_ASR_CertPers_2025.pdf",
      },
    ],
  },
  {
    title: "activity_report_2024_title",
    text: "activity_report_2024_text",
    downloadTitle: "activity_report_2024_download_title",
    downloadLinks: [
      {
        name: "activity_report_2024_download_name_pdf",
        url: "DownloadDocuments/Raport_referitor_la_activitatea_ASR_CertPers_2024.pdf",
      },
    ],
  },
];

const DownloadsPageComponent = () => {
  const { t } = useTranslation();

  return (
    <div className="downloads-page">
      <div className="downloads-grid-title-container">
        <p className="downloads-grid-title">{t("downloads_title")}</p>
        <h1 className="downloads-grid-subtitle">{t("downloads_subtitle")}</h1>
        <p className="downloads-grid-text">{t("downloads_description")}</p>
        <ScrollDownIndicator targetId="downloads-content" />
      </div>
      <div className="downloads-grid" id="downloads-content">
        <DownloadCardGrid downloadCardData={activityReports} />
      </div>
    </div>
  );
};
export default DownloadsPageComponent;
